import { DEFAULT_LOCALE } from "./constants";
import { I18N_TRANSLATION_CATALOGS } from "./generated/translationCatalogs";
import { interpolateText } from "./interpolation";
import { lookupTranslation } from "./lookupTranslation";
import type { SupportedLocale, TranslationCatalogs, TuFunction } from "./types";

interface GetFixedTuOptions {
  catalogs?: TranslationCatalogs;
  fallbackLocale?: SupportedLocale;
  isEnabled?: boolean;
  locale?: SupportedLocale;
  namespace: string;
}

export function getFixedTu({
  catalogs = I18N_TRANSLATION_CATALOGS,
  fallbackLocale = DEFAULT_LOCALE,
  isEnabled = false,
  locale = DEFAULT_LOCALE,
  namespace,
}: GetFixedTuOptions): TuFunction {
  return (sourceText, options = {}) => {
    if (!isEnabled || locale === DEFAULT_LOCALE) {
      return interpolateText(sourceText, options.values);
    }

    const translation = lookupTranslation({
      catalogs,
      fallbackLocale,
      locale,
      namespace,
      sourceText,
    });

    return interpolateText(translation, options.values);
  };
}
